<template>
  <div class="chip form-control-alternative">
    <slot></slot>
    <i @click="$emit('onDelete')" class="fa fa-times delete-icon"></i>
  </div>
</template>
<script>
export default {
  name: 'Chip',
};
</script>
<style lang="scss" scoped>
  .chip{
    background: white;
    padding: .5rem 1rem;
    border-radius: 5px;
  }
  .delete-icon{
    padding-left: 1rem;
    opacity: .6;
    cursor: pointer;
  }
</style>
